// Figma "Job Status" / "Route Status". Tones name a lifecycle stage, not a hue; the Tailwind
// `tone-*` colours are built from this file, so it must stay import-free.
export const STATUS_TONE_HEX = {
  pending: { fill: "#EAB308", strong: "#CA8A04", text: "#FFFFFF" },
  assigned: { fill: "#DBEAFE", strong: "#BFDBFE", text: "#2563EB" },
  active: { fill: "#3B82F6", strong: "#2563EB", text: "#FFFFFF" },
  done: { fill: "#22C55E", strong: "#16A34A", text: "#FFFFFF" },
  cancelled: { fill: "#667489", strong: "#475569", text: "#FFFFFF" },
  failed: { fill: "#EF4444", strong: "#DC2626", text: "#FFFFFF" },
} as const;

export type StatusTone = keyof typeof STATUS_TONE_HEX;

// Literal class names: packages/lib is outside every app's Tailwind content, so these are safelisted.
export const STATUS_TONE_CLASS: Record<StatusTone, { bg: string; color: string }> = {
  pending: { bg: "bg-tone-pending", color: "text-white" },
  assigned: { bg: "bg-tone-assigned", color: "text-tone-assigned-text" },
  active: { bg: "bg-tone-active", color: "text-white" },
  done: { bg: "bg-tone-done", color: "text-white" },
  cancelled: { bg: "bg-tone-cancelled", color: "text-white" },
  failed: { bg: "bg-tone-failed", color: "text-white" },
};

/** Keyed by the proto enum value name, e.g. "JOB_STATUS_CREATED". */
export const JOB_STATUS_TONE: Record<string, StatusTone> = {
  JOB_STATUS_CREATED: "pending",
  JOB_STATUS_ASSIGNED: "assigned",
  JOB_STATUS_ENROUTE: "active",
  JOB_STATUS_ON_SERVICE: "active",
  JOB_STATUS_COMPLETED: "done",
  JOB_STATUS_FORCE_COMPLETED: "done",
  JOB_STATUS_CANCELLED: "cancelled",
  JOB_STATUS_NOT_COMPLETED: "failed",
};

/** Keyed by the proto enum value name, e.g. "ROUTE_STATUS_CREATED". */
export const ROUTE_STATUS_TONE: Record<string, StatusTone> = {
  ROUTE_STATUS_NOT_APPROVED: "pending",
  ROUTE_STATUS_CREATED: "assigned",
  ROUTE_STATUS_IN_PROGRESS: "active",
  ROUTE_STATUS_RETURNING: "active",
  ROUTE_STATUS_COMPLETED: "done",
  ROUTE_STATUS_FORCE_COMPLETED: "done",
  ROUTE_STATUS_CANCELLED: "cancelled",
};
